import { render, staticRenderFns } from "./areaManage.vue?vue&type=template&id=5bed6952&scoped=true&"
import script from "./areaManage.vue?vue&type=script&lang=js&"
export * from "./areaManage.vue?vue&type=script&lang=js&"
import style0 from "./areaManage.vue?vue&type=style&index=0&id=5bed6952&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bed6952",
  null
  
)

export default component.exports